import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// attach bearer fallback if cookie is blocked
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bazaro_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Lang"] = document.documentElement.lang === "en" ? "en" : "ar";
  return config;
});

export function imageUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http") || pathOrUrl.startsWith("/")) return pathOrUrl;
  return `${API}/files/${pathOrUrl}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "حدث خطأ ما، حاول مرة أخرى.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
